import React from "react";
import { connect } from "react-redux";

import {
  getStudentClubBookingIDList,
  getSchoolByStudentID,
  isClubTopUpsEnabled,
  getStudentSchoolID,
  getGoToClubBookingID,
  canStudentDoClubTopUp,
  forceClubBookingForStudent
} from "state/school_money/selectors";
import { clearGoToClubBooking } from "state/school_money/actions";

import ScrollableList from "components/ScrollableList";
import List from "components/List";
import PlaceholderCard from "components/school_money/PlaceholderCard";
import StudentCreditBalance from "components/school_money/StudentCreditBalance";
import ClubCreditTopUp from "components/school_money/clubs/ClubCreditTopUp";
import ClubBooking from "components/school_money/clubs/ClubBooking";

class StudentClubBookingList extends React.Component {

  hasChildren() {
    return
  }

  render() {
    const { studentID, clubBookingIDList, school, isTopUpsEnabled, canStudentTopUp, forceClubBooking } = this.props;
    const placeholder = <PlaceholderCard objectName={"club bookings"} school={school} />;

    return (
      <ScrollableList className="club-booking-list" scrollTargetID={this.props.goToClubBookingID} onScroll={this.props.clearGoTo}>
        { refChild => (
          <React.Fragment>
          <StudentCreditBalance studentID={studentID} type="club_extended_services" />
          {
            (isTopUpsEnabled && canStudentTopUp && !forceClubBooking) ?
            <ClubCreditTopUp studentID={studentID} /> :
            <div>
              {(isTopUpsEnabled && canStudentTopUp && forceClubBooking) ? <ClubCreditTopUp studentID={studentID} /> : null}
              <List placeholder={placeholder}>
                {
                  clubBookingIDList.map(clubBookingID => (
                    <ClubBooking
                      key={clubBookingID}
                      clubBookingID={clubBookingID}
                      innerRef={ref => refChild(ref, clubBookingID)}
                    />
                  ))
                }
              </List>
            </div>
          }
          </React.Fragment>
        ) }
      </ScrollableList>
    )

  }

}

export default connect(
  (state, { studentID }) => ({
    clubBookingIDList: getStudentClubBookingIDList(state, studentID),
    school: getSchoolByStudentID(state, studentID),
    isTopUpsEnabled: isClubTopUpsEnabled(state, getStudentSchoolID(state, studentID)),
    goToClubBookingID: getGoToClubBookingID(state),
    canStudentTopUp: canStudentDoClubTopUp(state, studentID),
    forceClubBooking: forceClubBookingForStudent(state, studentID)
  }), {
    clearGoTo: clearGoToClubBooking
  }
)(StudentClubBookingList);



// WEBPACK FOOTER //
// ./src/components/school_money/clubs/StudentClubBookingList.js